import { render } from "./MyInput.vue?vue&type=template&id=127e5d08&scoped=true"
import script from "./MyInput.vue?vue&type=script&lang=js"
export * from "./MyInput.vue?vue&type=script&lang=js"

import "./MyInput.vue?vue&type=style&index=0&id=127e5d08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127e5d08"]])

export default __exports__